import {
  useActiveInsightsFilterCount,
  useInsightsFilterStore,
} from '@/features/insights/store/use-insights-hub-filter';
import {
  HubFilter,
  HubFilterOption,
} from '@/shared/components/filter/hub-filter';

export const InsightsHubFilter = () => {
  const filterStore = useInsightsFilterStore();

  return (
    <HubFilter
      {...filterStore}
      activeCount={() => useActiveInsightsFilterCount()}
      options={[
        HubFilterOption.PROJECT,
        HubFilterOption.SUBPROJECT,
        HubFilterOption.FILTER_RANGE,
      ].map((option) => ({
        option,
        allowMultiple: false,
      }))}
      showPredefinedPeriods={true}
    />
  );
};
